
export default {
  name: 'AppBadge',
  props: {
    type: {
      type: String,
      default: 'basic',
      validator: v => ['basic', 'information', 'media-count', 'new'].includes(v)
    },
    label: {
      type: String,
      default: ''
    }
  }
};
